// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"82edea4b","264":"14d55b78","290":"ef28b177","358":"e94408ac","420":"c8f4093c","571":"17b32d5f","672":"4fce4c8c"}[chunkId] + ".chunk.js";
};